import SafetyChecksBanner from './SafetyChecksBanner'

export default SafetyChecksBanner
